import { IShop, POSTSeedDataBody, POSTShopBody } from '.'
import { PUTLocalisationSettingsBody } from '../settings'
import { HttpMethod } from '../../http-method'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { IPaginatedRequest } from 'request'

export const getShop = (shopID: string) => ({
  url: `/modules/shops/${shopID}`,
  method: HttpMethod.GET
})

export const listShop = (params: any) => ({
  url: '/modules/shops',
  method: 'GET',
  params
})
export const listShopAll = (params: IPaginatedRequest) => ({
  url: '/modules/shops/all',
  method: 'GET',
  params
})

export const createShop = (data: POSTShopBody) => ({
  url: '/modules/shops',
  method: 'POST',
  data
})

export const updateShop = (shopID: string, data: Partial<IShop>) => ({
  url: `/modules/shops/${shopID}`,
  method: 'PUT',
  data
})

export const seedDataForShop = (data: POSTSeedDataBody) => ({
  url: '/modules/seed-data/working',
  method: 'POST',
  data
})

export const seedAccountancyDataForShopRequest = (data: POSTSeedDataBody) => ({
  url: '/modules/accountancy/seed-defaults',
  method: 'POST',
  data
})

export const listShopByCompanyUUID = (companyUUID: string) => ({
  method: 'GET',
  url: '/modules/shops',
  params: {
    Fields: [
      'Shop.ID',
      'Shop.Name',
      'Shop.PhoneNumber',
      'Shop.EmailAddress',
      'Shop.VisitorAddress',
      'Shop.VisitorCity',
      'Shop.VisitorHouseNumber',
      'Shop.VisitorHouseNumberAddition',
      'Shop.VisitorPostalCode',
      'Shop.VisitorCountry',
      'Shop.TenderEngineWorkshopID',
      'Shop.Status'
    ],
    Search: `Shop.CompanyUUID|=|${companyUUID}`
  }
})

export const supportAddShopToCRM = (shopID: string) => ({
  method: 'POST',
  url: `/modules/shops/${shopID}/crm`
})

export const getTakeoverUrl = (shopID: string) => ({
  method: 'GET',
  url: `/modules/shops/${shopID}/auth-url`
})

export const getTelesalesUrl = (shopID: string) => ({
  method: 'GET',
  url: `/modules/shops/${shopID}/telesales-url`
})

export const getShopLocalizationSettings = (shopID: string) => ({
  method: 'GET',
  url: `/modules/shops/${shopID}/settings/localization`
})

export const updateShopLocalizationSettings = (shopID: string, data: PUTLocalisationSettingsBody) => ({
  method: 'PUT',
  url: `/modules/shops/${shopID}/settings/localization`,
  data
})

export const supportUpdateShopsMijnGrossierRedirectRequest = (shopIDs: string[]) => ({
  method: HttpMethod.PUT,
  url: `/modules/shops/batch/set-mijn-grossier-redirect`,
  data: {
    ShopIDs: shopIDs
  }
})

export const updateShopSeenWelcomeScreenRequest = (seen: boolean) =>
  createAsyncApiAction<{}>('gms', {
    method: 'PUT',
    url: '/modules/shops/seen-welcome-screen',
    data: {
      ShouldSeeWelcomeScreen: seen
    }
  })

export const updateValidateShopDetailsStepRequest = (seen: boolean) =>
  createAsyncApiAction<{}>('gms', {
    method: 'PUT',
    url: '/modules/shops/validate-shop-details',
    data: {
      ShouldValidateShopDetails: seen
    }
  })
